// default implementation could be enhanced with assertInterfaceInit
let assertInterface = (assertion, message, ...substitution) => {
  if (typeof console === 'object') {
    console?.warn('initialize global assert/assertInterface with assertInterfaceInit first...'); // eslint-disable-line no-console
    if (!assertion) {
      console?.error(message, ...substitution); // eslint-disable-line no-console
    }
  }
  return assertion;
};
if (typeof self === 'object' && !self.assert) {
  // eslint-disable-line no-restricted-globals
  self.assert = assertInterface; // eslint-disable-line no-restricted-globals
}

// default implementation could be enhanced with assertInterfaceInit
let verifyInterface = (assertion, message, ...substitution) => {
  if (typeof console === 'object') {
    console.warn('initialize global verify/verifyInterface with assertInterfaceInit first...'); // eslint-disable-line no-console
    if (!assertion) {
      console?.error(message, ...substitution); // eslint-disable-line no-console
    }
  }
  return assertion;
};
if (typeof self === 'object' && !self.verify) {
  // eslint-disable-line no-restricted-globals
  self.verify = verifyInterface; // eslint-disable-line no-restricted-globals
}

export const assertInterfaceInit = ({ assert, verify }) => {
  assertInterface = assert || assertInterface;
  verifyInterface = verify || verifyInterface;
};

export const assert = (assertion, message, ...substitutions) => assertInterface?.(assertion, message, ...substitutions);
export const verify = (assertion, message, ...substitutions) => verifyInterface?.(assertion, message, ...substitutions);
